import { chakra } from '@chakra-ui/react'

export const Bar = chakra('div', {
    baseStyle: ({ theme }) => ({
        width: '100%',
        height: `${theme.headerHeight}px`,
        zIndex: theme.zIndexes.appHeader,
    }),
})
